export const toNumber = (data: unknown): number => {
  const numberData = Number(data);
  if (isNaN(numberData)) throw new Error(`${numberData} is not a number`);
  return numberData;
};

export const toNumberOrUndefined = (data: unknown): number | undefined => {
  const numberData = Number(data);
  return isNaN(numberData) ? undefined : numberData;
};

/** return number as a string with minimum 2 digits */
export const to2DigitsString = (value: number): string => {
  return value.toLocaleString(undefined, { minimumIntegerDigits: 2 });
};
